import { FC } from 'react';
import { Box, HStack, Square, Stack, Text, VStack } from '@chakra-ui/react';

export interface GuidanceStep {
  title: string;
  description?: string;
}

export interface GuidanceProps {
  steps: GuidanceStep[];
}

const Guidance: FC<GuidanceProps> = ({ steps }) => (
  <Stack gap="space-12">
    {steps.map((step, index) => (
      <>
        <HStack alignItems="start" gap="space-16" key={step.title}>
          <VStack alignSelf="stretch" gap="space-12">
            <Square
              backgroundColor="grey.200"
              borderRadius="radius-10"
              fontSize="13px"
              size="space-40"
              title={step.title}
            >
              <Text fontWeight="weight-500" variant="primary">
                {(index + 1).toString()}
              </Text>
            </Square>

            {index < steps.length - 1 ? (
              <Box
                alignSelf="center"
                backgroundColor="grey.200"
                height="100%"
                width="1.5px"
              />
            ) : null}
          </VStack>

          <VStack
            alignItems="start"
            gap="space-2"
            justifyContent="center"
            marginBottom={step.description ? '30px' : '42px'}
            minHeight="space-40"
          >
            <Text fontWeight="weight-500" size="md" variant="primary">
              {step.title}
            </Text>

            {step.description ? <Text>{step.description}</Text> : null}
          </VStack>
        </HStack>
      </>
    ))}
  </Stack>
);

export default Guidance;
